module.exports = __webpack_public_path__ + "img/download_orange.f5b32abf.jpg";